<template>
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2109 0.445312C4.81738 0.445312 0.445312 4.81738 0.445312 10.2109V34.8467C2.02686 31.4995 3.90918 26.6313 8.25781 21.5391C8.64844 18.0234 3.57031 14.8984 3.57031 14.8984C8.36963 14.4062 10.4551 16.9375 11.3413 18.8779C16.9795 13.0093 24.7354 7.66553 35.0156 5.91406C35.0156 5.91406 29.1777 8.00293 22.354 14.1997C25.0547 14.1172 30.9141 17.2422 31.6953 21.9297C31.6953 21.9297 24.0781 16.2656 18.8047 18.2188C14.0762 23.1113 10.1724 28.4448 6.58691 37.9453H28.1797C33.5732 37.9453 37.9453 33.5732 37.9453 28.1797V0.445312H10.2109Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ProductMenuIcon6',
} as DefineComponent
</script>
